module.exports = {
      id: "menu-usage",
      viewBox: "0 0 20 21.5",
      url: __webpack_public_path__ + "img/icons.05c569e2.svg#menu-usage",
      toString: function () {
        return this.url;
      }
    }